import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

export const repurposeContent = createAsyncThunk(
    'repurposer/repurposeContent',
    async ({ text, platform }, { rejectWithValue }) => {
        try {
            const response = await apiCall('/repurpose-content', 'POST', { text, platform });
            if (response.error) {
                return rejectWithValue(response.message || response.error);
            }
            return response;
        } catch (error) {
            return rejectWithValue('Error repurposing content');
        }
    }
);

const repurposerSlice = createSlice({
    name: 'repurposer',
    initialState: {
        lastResult: null,
        loading: false,
        error: null,
        platforms: {
            linkedin: { content: null, loading: false, error: null },
            twitter: { content: null, loading: false, error: null },
            instagram: { content: null, loading: false, error: null },
            email: { content: null, loading: false, error: null },
            seo: { content: null, loading: false, error: null }
        }
    },
    reducers: {
        clearRepurposer: (state) => {
            state.platforms = {
                linkedin: { content: null, loading: false, error: null },
                twitter: { content: null, loading: false, error: null },
                instagram: { content: null, loading: false, error: null },
                email: { content: null, loading: false, error: null },
                seo: { content: null, loading: false, error: null }
            };
            state.lastResult = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(repurposeContent.pending, (state, action) => {
                const platform = action.meta.arg.platform;
                state.loading = true;
                state.error = null;
                if (state.platforms[platform]) {
                    state.platforms[platform].loading = true;
                    state.platforms[platform].error = null;
                }
            })
            .addCase(repurposeContent.fulfilled, (state, action) => {
                const { platform, content } = action.payload;
                state.loading = false;
                state.lastResult = action.payload;
                if (state.platforms[platform]) {
                    state.platforms[platform].content = content;
                    state.platforms[platform].loading = false;
                }
            })
            .addCase(repurposeContent.rejected, (state, action) => {
                const platform = action.meta.arg.platform;
                state.loading = false;
                state.error = action.payload || 'An unexpected error occurred';
                if (state.platforms[platform]) {
                    state.platforms[platform].loading = false;
                    state.platforms[platform].error = action.payload;
                }
            });
    },
});

export const selectPlatformState = (state, platform) => state.repurposerSlice.platforms[platform];

export const { clearRepurposer } = repurposerSlice.actions;
export default repurposerSlice.reducer;
